const { primitives } = require('../../primitives')

const borderVariables = {
  default: primitives['neutral'][400],
  'default-hover': primitives['neutral'][500],
  subtle: primitives['neutral'][300],
  'subtle-hover': primitives['neutral'][400],
  strong: primitives['neutral'][600],
  'strong-hover': primitives['neutral'][700],
  selected: primitives['neon-blue'][600],
  contrast: primitives['forest'][900],
}

module.exports = { borderVariables }
